export default "__VITE_ASSET__CBZa5L_$__"